<template>
  <div v-if="isMenu == 1" style="width: 100%; max-width: 100%;">
    <!-- Sidebar -->
    <aside class="sidebar" ref="sidebar">
      <div>
        <!-- Logo -->
        <div class="logo">
          <!-- If logo image exists -->
          <img v-if="brandDt.logo" :src="brandDt.logo" :alt="brandDt.app_short_name" class="logo-img"
            style="background-color: #000; border-radius: 50%; width: 2.4rem;" />

          <!-- If no image → show initials -->
          <div class="logo-circle" v-else>
             <img :src="brandDt.app_short_name" :alt="brandDt.app_short_name" class="logo-img"
            style="background-color: #000; border-radius: 50%; width: 2.4rem;" />
          </div>
          <span>{{ brandDt.app_name }}</span>
        </div>
        <!-- Menu -->
        <div class="menu" v-if="utype==='user'">
          <!-- Dashboard -->
          <div :class="'menu-item ' + chk_item(0)" @click="set_item(0)">
            <i class="bx bx-home"></i>
            Dashboard
          </div>
          <!-- Bookings with Submenu -->
          <div class="menu-group">
            <!-- toggleSubmenu('websites1') -->
            <div :class="'menu-item ' + chk_item(1)" @click="set_item(1)">
              <i class="bx bx-briefcase"></i>
              My Pages
              <!-- <i class="bx bx-chevron-down dropdown-icon" :class="{ open: openMenu === 'websites1' }"></i> -->
            </div>
            <!-- <transition name="slide-fade">
              <div v-if="openMenu === 'websites1'" class="submenu">
                <div class="submenu-item" @click="gotopage('my_pages')">All Pages</div> -->
                <!-- <div class="submenu-item" @click="gotopage('leads')">Leads</div>
                <div class="submenu-item" @click="gotopage('support_bot')">Chatbot</div>
                <div class="submenu-item" @click="gotopage('pricing_tables')">Pricing Tables</div> -->
              <!-- </div> -->
            <!-- </transition> -->
          </div>
          <!-- AI Assistant -->
          <div :class="'menu-item ' + chk_item(5)" @click="set_item(5)">
            <i class="bx bx-group"></i>
            Leads
          </div>
          <!-- Bookings with Submenu -->
          <div class="menu-group">
            <div :class="'menu-item ' + chk_item(2)" @click="toggleSubmenu('bookings')">
              <i class="bx bx-calendar"></i>
              Bookings
              <i class="bx bx-chevron-down dropdown-icon" :class="{ open: openMenu === 'bookings' }"></i>
            </div>
            <transition name="slide-fade">
              <div v-if="openMenu === 'bookings'" class="submenu">
                <div class="submenu-item" @click="gotopage('bookings')">All Bookings</div>
                <div class="submenu-item" @click="gotopage('booking_pages')">Booking Pages</div>
                <div class="submenu-item" @click="gotopage('routing_form')">Routing forms</div>
                <div class="submenu-item" @click="gotopage('packages_list')">Packages</div>
              </div>
            </transition>
          </div>

          <!-- Invoicing -->
          <div class="menu-group">
            <div :class="'menu-item ' + chk_item(3)" @click="toggleSubmenu('invoicing')">
              <i class="bx bx-file"></i>
              Invoicing
              <i class="bx bx-chevron-down dropdown-icon" :class="{ open: openMenu === 'invoicing' }"></i>
            </div>
            <transition name="slide-fade">
              <div v-if="openMenu === 'invoicing'" class="submenu">
                <div class="submenu-item" @click="gotopage('invoices')">All Invoices</div>
                <div class="submenu-item" @click="gotopage('clients')">Clients</div>
                <div class="submenu-item" @click="gotopage('items')">Items</div>
                <div class="submenu-item" @click="gotopage('expanses')">Expenses</div>
              </div>
            </transition>
          </div>

          <!-- Analytics -->
          <div :class="'menu-item ' + chk_item(4)" @click="set_item(4)">
            <i class="bx bx-bar-chart"></i>
            Payments
          </div>

          

          <!-- Settings -->
          <div class="menu-group">
            <div class="menu-item" :class="'menu-item ' + chk_item(6)" @click="set_item(6)">
              <i class="bx bx-cog"></i>
              Settings
            </div>
          </div>
        </div>
        <!-- Admin Menu -->
        <div class="menu" v-if="utype === 'admin'">
          <!-- Dashboard -->
          <div :class="'menu-item ' + chk_item(0)" @click="set_item(0)">
            <i class="bx bx-grid-alt"></i>
            Dashboard
          </div>

          <!-- User Management -->
          <div :class="'menu-item ' + chk_item(1)" @click="set_item(1)">
            <i class="bx bx-user-circle"></i>
            User Management
          </div>

          <!-- Subscription Management -->
          <div :class="'menu-item ' + chk_item(2)" @click="set_item(2)">
            <i class="bx bx-credit-card"></i>
            Subscription Management
          </div>

          <!-- Team Management -->
          <!-- <div :class="'menu-item ' + chk_item(3)" @click="set_item(3)">
            <i class="bx bx-group"></i>
            Team Management
          </div> -->
          <div class="menu-group">
            <div class="menu-item" :class="'menu-item ' + chk_item(3)" @click="set_item(3)">
              <i class="bx bx-cog"></i>
              Settings
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="sidebar-footer">
            <div class="video-box" 
          v-if="utype==='user' && isVidBox"
          style="position: relative;"
      >

        <div 
          style="position:absolute; top:10px; left:10px; cursor:pointer; z-index:10; 
                font-size:20px; background-color:#111827; border-radius:50%; 
                width:28px; height:28px; display:flex; align-items:center; 
                justify-content:center; color:#fff;"
          @click="closeVideoBox"
        >
          <i class='bx bx-x'></i>
        </div>

        <h4 class="video-title">Quick Tutorial</h4>

        <div class="video-thumb" @click="openVideo">
          <img src="/images/banner.png" alt="Video Thumbnail" />
          <div class="play-btn">
            <i class='bx bx-play'></i>
          </div>
        </div>

      </div>


        <div class="membership-card" v-if="utype==='user'">
          <div class="mc-left">
            <div class="membership-circle">
              {{ planName.substring(0,2).toUpperCase() || "AI" }}
            </div>
          </div>

          <div class="mc-right">
            <h4>{{ planName || "Free Plan" }}</h4>
            <span class="mc-small" style="display: inline-flex; align-items: center; gap: 4px;">
              <i class="bx bx-timer" style="font-size: 1.3rem; line-height: 1;"></i>
              {{ planRemaining }} left
            </span>

            <button 
              class="mc-upgrade-btn"
              v-if="userData!=null && userData.mem === '0'"
              @click="gotoplans()"
            >
              Upgrade
            </button>
          </div>
        </div>

        <div @click="logoutnow()" class="logout-btn">
          <i class="bx bx-log-out"></i> Logout
        </div>
      </div>
    </aside>

    <!-- Overlay -->
    <div class="sidebar-overlay" ref="overlay" @click="closeSidebar"></div>

    <!-- Hamburger (mobile) -->
    <div class="hamburger" @click="toggleSidebar">
      <i class="bx bx-menu"></i>
    </div>

    <!-- Main Section -->
    <div class="main">
      <header>
        <div class="nav-buttons" style="display: flex; justify-content: flex-start; margin: 1.2rem 0;">
          <button @click="gotohelp()" v-if="utype==='user'" class="active"
            style="display:flex;align-items:center;gap:8px;background:linear-gradient(135deg,#111827,#1f2937);color:#fff;border:none;padding:12px 18px;border-radius:10px;font-weight:600;font-size:14px;cursor:pointer;transition:all 0.3s ease;">
            <i class="bx bx-help-circle" style="font-size: 18px;"></i>
            Complete profile:
            <span style="font-weight:700; margin-left: 4px;">{{ compSteps }}/{{ totalSetps }} Completed</span>
          </button>
        </div>

        <div class="header-right">
          <div class="notification" @click="gotonoti()">
            <i class="bx bx-bell" style="font-size: 1.5rem"></i>
            <div v-if="unreadCount > 0" class="notification-count">{{ unreadCount }}</div>
          </div>

          <!-- Profile -->
          <div class="profile" ref="profile" @click.stop="toggleProfileMenu">
            <img :src="userAvatar" alt="user" />
            <div class="details">
              <span class="name">{{ userName }}</span>
              <span class="email">{{ userEmail }}</span>
            </div>
          </div>
        </div>
      </header>

      <!-- Profile Dropdown -->
      <transition name="fade-slide">
        <div v-if="isProfileMenuOpen" class="profile-menu" ref="profileMenu" @mouseleave="closeProfileMenu"
          @mouseenter="cancelClose">
          <button @click="settnow()" class="menu-item">
            <i class="bx bx-user-circle"></i>
            Profile Settings
          </button>
          <button @click="settnow()" class="menu-item">
            <i class="bx bx-lock-alt"></i>
            Change Password
          </button>
          <div class="divider"></div>
          <button @click="logoutnow()" class="menu-item logout">
            <i class="bx bx-log-out-circle"></i>
            Logout
          </button>
        </div>
      </transition>

      <!-- Content -->
      <div class="content">
        <router-view />
      </div>

      <!-- <footer class="fixed-footer">
        © 2025 Julytoss Dashboard. All rights reserved.
      </footer> -->
    </div>

    <IntroPopup />
  </div>

  <!-- If not logged in -->
  <div v-else style="width: 100%; max-width: 100%;">
    <router-view></router-view>
  </div>

  <transition name="fade">
    <div v-if="showLogoutConfirm" class="logout-overlay">
      <div class="logout-box">
        <i class="bx bx-log-out-circle logout-icon"></i>
        <h3>Logout!!</h3>
        <p>Are you sure you want to log out of your account?</p>
        <div class="logout-actions">
          <button class="btn-cancel" @click="showLogoutConfirm = false">Cancel</button>
          <button class="btn-logout" @click="confirmLogout">Logout</button>
        </div>
      </div>
    </div>
  </transition>

  <!-- 🎥 VIDEO POPUP -->
<transition name="fade">
  <div v-if="showVideoPopup" class="video-overlay" @click="closeVideo">
    <div class="video-popup" @click.stop>
      <button class="video-close" @click="closeVideo">
        <i class='bx bx-x'></i>
      </button>

      <video
        ref="tutorialVideo"
        controls
        autoplay
        class="video-player"
      >
        <source :src="api_base_url+'/assets/banner.mp4'" type="video/mp4" />
      </video>
    </div>
  </div>
</transition>

</template>


<script>
  import { ref, onMounted, onBeforeUnmount } from "vue";
  import IntroPopup from "@/comps/IntroPopup.vue";
  import { getUserById } from "@/apis/authapis";
  import { getAdminSettings } from "@/apis/aupadminapis";
  import { apiBaseUrl } from "@/apis/appconst";

  import {
    checkIntegration
  } from "@/apis/adminapis";
  import { getBookPages } from "@/apis/bookpageapis";
  import { getProfiles } from "@/apis/profileapi";

  import {
    getPackages
  } from "@/apis/pkgapis";


  import {
    getUnreadNotiCount
  } from "@/apis/authapis";

  export default {
    name: "App",
    components: { IntroPopup },

    setup() {
      const sidebar = ref(null);
      const overlay = ref(null);
      
      const profile = ref(null);
      const profileMenu = ref(null);
      const isProfileMenuOpen = ref(false);
      let hideTimeout = null;

      const toggleSidebar = () => {
        sidebar.value?.classList.toggle("active");
        overlay.value?.classList.toggle("active");
      };

      const closeSidebar = () => {
        sidebar.value?.classList.remove("active");
        overlay.value?.classList.remove("active");
      };

      const toggleProfileMenu = () => {
        isProfileMenuOpen.value = !isProfileMenuOpen.value;
      };

      const closeProfileMenu = () => {
        isProfileMenuOpen.value = false;
      };

      const cancelClose = () => clearTimeout(hideTimeout);

      const handleClickOutside = (event) => {
        if (
          profile.value &&
          !profile.value.contains(event.target) &&
          !profileMenu.value?.contains(event.target)
        ) {
          closeProfileMenu();
        }
      };

      onMounted(() => {
        document.addEventListener("click", handleClickOutside);
        window.addEventListener("resize", () => {
          if (window.innerWidth > 768) closeSidebar();
        });


      });

      onBeforeUnmount(() => {
        document.removeEventListener("click", handleClickOutside);
      });

      return {
        sidebar,
        overlay,
        profile,
        profileMenu,
        isProfileMenuOpen,
        toggleSidebar,
        closeSidebar,
        toggleProfileMenu,
        closeProfileMenu,
        cancelClose,
      };
    },

    data() {
      return {
        api_base_url:"",
        showVideoPopup:false,
        brandDt: {
          logo: "",
          fav: "",
          app_name: "Julytoss",
          app_short_name: "images/logo.png",
        },
        totalSetps:5,
        compSteps:0,
        unreadCount: 0,
        unreadInterval: null,
        menu_pos: 0,
        isVidBox: true,
        showLogoutConfirm: false,
        isMenu: 1,
        openMenu: null,
        utype: "user",
        userName: "Loading...",
        userEmail: "",
        userAvatar: "images/uplace.jpg",

        planName: "",
        planRemaining: "0 Days",
        planStatus: "Active",
        userId: null,
      };
    },
    
    async mounted() {
      this.api_base_url = apiBaseUrl;
      const vidbox45 = sessionStorage.getItem("vidbox45");
      if(vidbox45 && vidbox45.length>0){
        this.isVidBox = vidbox45.localeCompare("true")==0;
      }
      const ldataRaw = sessionStorage.getItem("ldata");
      const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;

      if (!ldata) {
        this.isMenu = 0;
        return;
      }
      const segments = window.location.pathname.split("/").filter(seg => seg !== "");
      if (
        segments && (window.location.pathname + "").includes("web_editor") ||
        segments && (window.location.pathname + "").includes("new_single_web") ||
        segments && (window.location.pathname + "").includes("appointment") ||
        segments && (window.location.pathname + "").includes("invoice/")
      ) {
        this.isMenu = 0;
      }
      else {
        this.isMenu = 1;
      }
      this.userId = ldata.user_id;
      this.utype = ldata.type || "user";
      this.fetchUnreadCount();  // Load immediately
      this.startUnreadPolling();
      this.loadAiPgSettings();
      // ✅ Fetch real-time user data
      try {
        const userData = await getUserById(this.userId);
        if (userData) {
          this.userName = `${userData.fname || ""} ${userData.lname || ""}`.trim();
          this.userEmail = userData.email || "";
          if(userData.avatar!=null && userData.avatar!=undefined && userData.avatar.length>0){
            this.userAvatar = apiBaseUrl+userData.avatar || "images/uplace.jpg";
          }

          this.planName = userData.user_plan_name || "Free Plan";
          this.planRemaining = userData.mem1 || "0 Days";
          this.planStatus = userData.mem === "1" ? "Active" : "Expired" || "Active";
        }
      } catch (err) {
        console.error("Error fetching user details:", err);
      }

      // ✅ Optional: Load plan data from session


      // ✅ Determine current active menu
      const url = window.location.href;
      if (
        url.includes("my_pages") ||
        url.includes("leads") ||
        url.includes("support_bot") ||
        url.includes("pricing_tables")
      ) {
        this.menu_pos = 1;
      }
      else if (
        url.includes("bookings") ||
        url.includes("booking_pages") ||
        url.includes("routing_form") ||
        url.includes("packages_list")
      ) {
        this.menu_pos = 2;
      }
      else if (
        url.includes("invoices") ||
        url.includes("clients") ||
        url.includes("items") ||
        url.includes("expanses")
      ) {
        this.menu_pos = 3;
      }
      else if (url.includes("payments")) {
        this.menu_pos = 4;
      }
      else if (url.includes("assistant")) {
        this.menu_pos = 5;
      }
      else if (url.includes("settings")) {
        this.menu_pos = 6;
      }
      else {
        this.menu_pos = 0;
      }

      this.checkSteps1();
    },

    methods: {
      async checkSteps1(){
         const google = await checkIntegration(this.userId, "Google Calendar", "google_calendar");
    const paypal = await checkIntegration(this.userId, "PayPal", "payment");
    const stripe = await checkIntegration(this.userId, "Stripe", "payment");
    const razorpay = await checkIntegration(this.userId, "Razorpay", "payment");
    const gmail = await checkIntegration(this.userId, "Gmail", "email");

    // 🔹 Auto mark steps as completed
    if (google?.status) {this.compSteps++;}
    if (paypal?.status || stripe?.status || razorpay?.status)
    { this.compSteps++; }
    if (gmail?.status){
      this.compSteps++;
    }


    const res = await getBookPages(
      this.userId,
      "0",
      "",
      "",
      ""
    );
    if (res.status && res.records?.length) {
      this.compSteps++;
    }

    const res1 = await getPackages(
      this.userId,
      "0",
      "",
      ""
    );
    if (res1?.status && res1?.records?.length > 0) {
      this.compSteps++;
    }

    const res2 = await getProfiles(this.userId, "0", "");
    if (res2?.status) {
      this.compSteps++;
    }
      },
    closeVideoBox() {
      this.isVidBox = false;
      sessionStorage.setItem("vidbox45",this.isVidBox+"");
    },
      openVideo() {
        this.showVideoPopup = true;

        // Auto play by resetting video
        this.$nextTick(() => {
          const video = this.$refs.tutorialVideo;
          if (video) {
            video.currentTime = 0;
            video.play();
          }
        });
      },

      closeVideo() {
        this.showVideoPopup = false;

        // Stop video when closing
        const video = this.$refs.tutorialVideo;
        if (video) video.pause();
      },
      getYoutubeId(url) {
        try {
          const regExp = /(?:v=|youtu\.be\/|embed\/)([^#&?]+)/;
          const match = url.match(regExp);
          return match ? match[1] : "";
        } catch (e) {
          return "";
        }
      },
      async loadAiPgSettings() {
        try {
          this.loading = true;

          const res = await getAdminSettings();

          if (res.status && res.settings) {
            const settings = res.settings;

            this.brandDt.app_name = settings.app_name;
            this.brandDt.logo = (settings.app_logo.length > 0) ? (apiBaseUrl + settings.app_logo) : "";
            this.brandDt.fav = (settings.app_fav.length > 0) ? (apiBaseUrl + settings.app_fav) : "";

          }

        } catch (err) {
          console.error("loadAiPgSettings error:", err);
        } finally {
          this.loading = false;
        }
      },
      gotonoti() {
        window.location.href = "/notifications";
      },
      startUnreadPolling() {
        this.unreadInterval = setInterval(() => {
          this.fetchUnreadCount();
        }, 3000);
      },
      async fetchUnreadCount() {
        try {
          const ldata = JSON.parse(sessionStorage.getItem("ldata") || "{}");

          const res = await getUnreadNotiCount(ldata.user_id);

          if (res.status) {
            this.unreadCount = res.count || 0;
          }
        } catch (err) {
          console.error("Unread count error:", err);
        }
      }
      ,
      logoutnow() {
        this.showLogoutConfirm = true;
      },
      confirmLogout() {
        sessionStorage.removeItem("ldata");
        this.showLogoutConfirm = false;
        window.location.reload();
      },
      gotohelp() {
        window.location.href = "/help";
      },
      toggleSubmenu(menu) {
        this.openMenu = this.openMenu === menu ? null : menu;
      },
      gotopage(url) {
        if (!url) return;
        window.location.href = "/" + url;
        if (url === "my_pages" || url === "support_bot" || url === "pricing_tables" || url === "leads")
            this.menu_pos = 1;
        else if (url === "bookings" || url === "booking_pages" || url === "routing_form" || url === "packages_list")
            this.menu_pos = 2;
        else if (url === "invoices" || url === "clients" || url === "items" || url === "expanses")
            this.menu_pos = 3;
        else if (url === "payments")
            this.menu_pos = 4;
        else if (url === "assistant")
            this.menu_pos = 5;
        else if (url === "settings")
            this.menu_pos = 6;
        else this.menu_pos = 0;
    },
      gotoplans() {
        window.location.href = "/plans";
      },
      settnow() {
        if (this.utype === "admin") {
          window.location.href = "/admin_settings";
        } else {
          window.location.href = "/settings";
        }
      },
      set_item(pos) {
        this.menu_pos = pos;
        if (pos == 0) window.location.href = "/";
        else if (pos == 1)
          this.utype === "admin"
            ? (window.location.href = "/users")
            : (window.location.href = "/my_pages");
        else if (pos == 2)
          this.utype === "admin"
            ? (window.location.href = "/admin_plans")
            : (window.location.href = "/bookings");
        else if (pos == 3)
          this.utype === "admin"
            ? (window.location.href = "/admin_settings")
            : (window.location.href = "/invoices");
        else if (pos == 4) this.utype === "admin"
          ? (window.location.href = "/admin_settings")
          : (window.location.href = "/payments");
        else if (pos == 5) window.location.href = "/leads";
        else if (pos == 6) window.location.href = "/settings";
      },
      chk_item(pos) {
        return this.menu_pos === pos ? "active" : "";
      },
    },
  };
</script>




<style>
  /* === FIXED FOOTER === */
  .fixed-footer {
    /* position: fixed; */
    bottom: 0;
    left: 15rem;
    /* Same as sidebar width */
    right: 0;
    height: 48px;
    background: #fff;
    border-top: 1px solid var(--border);
    color: var(--muted);
    font-size: 12px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.05);
  }


  /* === CONTENT (Desktop Default) === */
  .content {
    padding: 24px;
    margin: 0 auto;
    width: 80vw;
    max-width: 80vw;
    flex: 1;
    box-sizing: border-box;
    transition: all 0.3s ease;
  }

  /* === Tablet & Mobile Adjustments === */
  @media (max-width: 1024px) {
    .content {
      width: 100%;
      max-width: 100%;
      padding: 20px;
    }
  }

  @media (max-width: 768px) {
    .content {
      width: 100% !important;
      max-width: 100% !important;
      padding: 16px;
      margin: 0;
    }
  }



  @media (max-width: 768px) {
    .fixed-footer {
      left: 0;
    }
  }

  /* === PROFILE MENU === */
  .profile-menu {
    position: absolute;
    top: 60px;
    right: 20px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    padding: 8px 0;
    width: 200px;
    display: flex;
    flex-direction: column;
    z-index: 1000;
  }

  .divider {
    border-top: 1px solid #e5e7eb;
    margin: 6px 0;
  }

  /* === Animation === */
  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: all 0.25s ease;
  }

  .fade-slide-enter-from,
  .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-6px) scale(0.95);
  }

  /* === Submenu Styles === */
  .menu-group {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    .nav-buttons {
      display: none !important;
    }
  }

  .submenu {
    background: #f9fafb;
    padding-left: 2.5rem;
    border-left: 2px solid var(--border);
    display: flex;
    flex-direction: column;
  }

  .submenu-item {
    padding: 8px 0;
    color: var(--muted);
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .submenu-item:hover {
    color: var(--primary);
    transform: translateX(4px);
  }

  /* Dropdown arrow rotation */
  .dropdown-icon {
    margin-left: auto;
    transition: transform 0.3s ease;
  }

  .dropdown-icon.open {
    transform: rotate(180deg);
  }

  /* Smooth expand / collapse animation */
  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.25s ease;
    overflow: hidden;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-6px);
  }

  /* === ✅ Scrollable Sidebar (Mobile Only) === */
  @media (max-width: 992px) {
    .sidebar {
      height: 100vh;
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      /* smooth scroll on iOS */
      scrollbar-width: thin;
      scrollbar-color: #d1d5db transparent;
    }

    .sidebar::-webkit-scrollbar {
      width: 6px;
    }

    .sidebar::-webkit-scrollbar-thumb {
      background: #d1d5db;
      border-radius: 6px;
    }
  }

  /* === Logout Confirmation Modal === */
  .logout-overlay {
    position: fixed;
    inset: 0;
    background: rgba(17, 24, 39, 0.55);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .logout-box {
    background: #ffffff;
    border-radius: 16px;
    padding: 32px 28px;
    width: 90%;
    max-width: 380px;
    text-align: center;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
    animation: scaleIn 0.3s ease;
  }

  .logout-icon {
    font-size: 3rem;
    color: #111827;
    margin-bottom: 10px;
  }

  .logout-box h3 {
    margin: 0;
    font-size: 1.3rem;
    font-weight: 600;
    color: #111827;
  }

  .logout-box p {
    margin: 10px 0 20px;
    color: #6b7280;
    font-size: 0.95rem;
  }

  .logout-actions {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 10px;
  }

  .logout-actions button {
    min-width: 100px;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s ease;
  }

  .btn-cancel {
    background: #f3f4f6;
    border: 1px solid #d1d5db;
    color: #374151;
  }

  .btn-cancel:hover {
    background: #e5e7eb;
  }

  .btn-logout {
    background: linear-gradient(135deg, #111827, #1e3a8a);
    color: #fff;
    border: none;
  }

  .btn-logout:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  /* Fade animation */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  /* Pop animation */
  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.92);
    }

    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  /* 🎥 Video Tutorial Box */
.video-box {
  background: #f3f4f6;
  padding: 14px;
  border-radius: 14px;
  margin-bottom: 1rem;
  text-align: center;
  border: 1px solid #e5e7eb;
}

.video-box .video-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #111827;
}

.video-thumb {
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}

.video-thumb img {
  width: 100%;
  border-radius: 10px;
}

.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(17, 24, 39, 0.9);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
  backdrop-filter: blur(4px);
}

.video-btn {
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  background: #111827;
  color: #fff;
  font-size: 13px;
  border: none;
  cursor: pointer;
  transition: 0.2s;
}

.video-btn:hover {
  background: #1f2937;
}
/* === VIDEO POPUP OVERLAY === */
.video-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.75);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

/* === POPUP CONTAINER === */
.video-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;

  width: 900px;       /* FIXED LANDSCAPE SIZE */
  max-width: 90vw;    /* Responsive fallback */
  height: 520px;      /* FIXED LANDSCAPE HEIGHT */
  max-height: 90vh;

  box-shadow: 0 8px 30px rgba(0,0,0,0.30);
  animation: popupScale 0.25s ease;
}

/* === CLOSE BUTTON === */
.video-close {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #111827;
  color: #fff;
  border: none;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  z-index: 10;
}
.video-close:hover {
  opacity: 0.9;
}

/* === VIDEO PLAYER === */
.video-player {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;      /* Fill the popup beautifully */
  border-radius: 14px;    /* Rounded corners (matches popup) */
  background: #000;       /* Fallback background */
}


/* === POPUP ANIMATION === */
@keyframes popupScale {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Fade transition for overlay */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
/* ==== NEW COMPACT MEMBERSHIP CARD ==== */
.membership-card {
  display: flex;
  align-items: center;
  gap: 12px;
   background: linear-gradient(135deg, #111827, #1f2937, #374151);
  border: 1px solid #e5e7eb;
  padding: 10px 12px;
  border-radius: 12px;
  margin-top: 12px;
  margin-bottom: 12px;
  transition: 0.2s ease;
}

.membership-card:hover {
  background: #111827;
  border-color: #111827;
}

.membership-circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #fff;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
}

.mc-right h4 {
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  text-align: left;
  line-height: 18px;
}

.mc-small {
  font-size: 12px;
  color: #ffffff;
  display: block;
  margin-top: 2px;
}

.mc-upgrade-btn {
  margin-top: 6px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.25s ease;
}

.mc-upgrade-btn:hover {
  background: #1f2937;
  transform: translateY(-2px);
}

</style>